const apiAddress = import.meta.env.VITE_API_ADDRESS;
export default apiAddress;
